import React from "react";
import { mortgageServices } from "../data";

function Mortgages() {
  return (
    <section className="section">
      <div className="section-header">
        <span className="section-kicker">Mortgage Advice</span>
        <h2 className="section-title">
          First home, investment, business lending & restructuring
        </h2>
        <p className="section-subtitle">
          Most people take out a mortgage two or three times in their life, and
          the bank does it a thousand times a day. We work out what you can
          borrow, how the loan should be structured, and which lenders suit your
          situation, so the gap in experience matters less.
        </p>
      </div>

      <div className="subnav">
        <a href="#first-home">First Home</a>
        <a href="#investment">Property Investment</a>
        <a href="#business">Business Loan</a>
        <a href="#restructure">Loan Restructuring</a>
        <a href="#debt">Debt Consolidation</a>
        <a href="#mortgage-insurance">Mortgage Insurance</a>
      </div>

      {mortgageServices.map((service) => (
        <section
          key={service.id}
          id={service.id}
          style={{ marginBottom: "30px" }}
        >
          <div className="card">
            <div className="card-icon">{service.icon}</div>
            <div className="card-title">{service.title}</div>
            <p className="card-text">{service.short}</p>
            <ul style={{ fontSize: "13px", color: "#4b5563" }}>
              {service.bullets.map((b) => (
                <li key={b}>{b}</li>
              ))}
            </ul>
          </div>
        </section>
      ))}

      <div className="card" style={{ marginTop: "20px" }}>
        <div className="card-title">Our process</div>
        <ol style={{ fontSize: "13px", color: "#4b5563", paddingLeft: "18px" }}>
          <li>A short call or online meeting to find out what you are after</li>
          <li>
            We ask you for the paperwork (income, assets, liabilities, and so on)
          </li>
          <li>
            We compare lenders and come back with structures that fit your
            situation
          </li>
          <li>We put the application together and do the negotiating</li>
          <li>
            After settlement we stay in touch and review the lending as rates roll off
          </li>
        </ol>
        <p style={{ fontSize: "12px", color: "#6b7280", marginTop: "8px" }}>
          There is usually no cost to you for our mortgage advice — we are paid
          by the lender when your loan is settled (we will always let you know
          if a fee applies in your case).
        </p>
      </div>
    </section>
  );
}

export default Mortgages;
